document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-duo-picker]').forEach(initDuoPicker);
});

function initDuoPicker(root) {
  var anchor = document.querySelector('[id^="Quantity-Form-"]');
  if (anchor && anchor.parentNode) {
    anchor.parentNode.insertBefore(root, anchor);
    anchor.style.display = 'none';
  }
  root.classList.remove('duo-picker--pending');

  var rowsContainer = root.querySelector('[data-duo-rows]');
  var addBtn = root.querySelector('[data-duo-add]');
  var errorEl = root.querySelector('[data-duo-error]');
  var countEl = root.querySelector('[data-duo-count]');
  if (!rowsContainer) return;

  var rowTemplate = rowsContainer.querySelector('[data-duo-row]');
  var MAX_TOTAL = parseInt(root.getAttribute('data-duo-max') || '2', 10);

  var form = document.querySelector('product-form form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  var addToCartBtn = form ? (form.querySelector('[name="add"]') || form.querySelector('.product-form__submit')) : null;
  if (!addToCartBtn) addToCartBtn = document.querySelector('.product-form__submit, [name="add"]');
  var addToCartText = addToCartBtn ? (addToCartBtn.querySelector('span') || addToCartBtn) : null;
  var originalBtnText = addToCartText ? addToCartText.textContent.trim() : 'Add to cart';

  function ensureHiddenInput(name) {
    if (!form) return null;
    var input = form.querySelector('input[name="properties[' + name + ']"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      form.appendChild(input);
    }
    return input;
  }

  function closeAllPanels() {
    root.querySelectorAll('[data-duo-panel]').forEach(function (p) { p.setAttribute('hidden', ''); });
    root.querySelectorAll('[data-duo-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }
  document.addEventListener('click', closeAllPanels);

  function getRows() {
    return Array.prototype.slice.call(rowsContainer.querySelectorAll('[data-duo-row]'));
  }

  function rowQty(row) {
    if (!row.getAttribute('data-scent-title')) return 0;
    return parseInt(row.getAttribute('data-qty') || '1', 10);
  }

  function totalSelected() {
    return getRows().reduce(function (sum, row) { return sum + rowQty(row); }, 0);
  }

  function updateSubmitState() {
    var remaining = MAX_TOTAL - totalSelected();
    if (!addToCartBtn) return;
    if (remaining > 0) {
      addToCartBtn.disabled = true;
      addToCartBtn.setAttribute('aria-disabled', 'true');
      if (addToCartText) addToCartText.textContent = 'Select ' + remaining + ' more scent' + (remaining > 1 ? 's' : '');
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.removeAttribute('aria-disabled');
      if (addToCartText) addToCartText.textContent = originalBtnText;
    }
  }

  function updateCount() {
    if (countEl) countEl.textContent = totalSelected() + ' of ' + MAX_TOTAL + ' scents selected';
    updateSubmitState();
  }

  function updateProperties() {
    var flat = [];
    getRows().forEach(function (row) {
      var title = row.getAttribute('data-scent-title');
      var handle = row.getAttribute('data-scent-handle');
      if (!title) return;
      for (var i = 0; i < rowQty(row); i++) flat.push({ title: title, handle: handle });
    });
    for (var i = 0; i < MAX_TOTAL; i++) {
      var entry = flat[i];
      var titleInput = ensureHiddenInput('Scent ' + (i + 1));
      var handleInput = ensureHiddenInput('_Scent ' + (i + 1) + ' Handle');
      if (titleInput) titleInput.value = entry ? entry.title : '';
      if (handleInput) handleInput.value = entry ? entry.handle : '';
    }
  }

  function refreshRowConstraints() {
    var rows = getRows();
    var total = totalSelected();

    rows.forEach(function (row) {
      var qty = rowQty(row);
      var others = total - qty;
      var maxForRow = MAX_TOTAL - others;
      var minusBtn = row.querySelector('[data-duo-qty-minus]');
      var plusBtn = row.querySelector('[data-duo-qty-plus]');
      var qtyValueEl = row.querySelector('[data-duo-qty-value]');
      var removeBtn = row.querySelector('[data-duo-remove]');
      var current = parseInt(row.getAttribute('data-qty') || '1', 10);

      if (current > maxForRow && maxForRow >= 1) {
        current = maxForRow;
        row.setAttribute('data-qty', String(current));
        if (qtyValueEl) qtyValueEl.textContent = String(current);
      }
      if (minusBtn) minusBtn.disabled = current <= 1;
      if (plusBtn) plusBtn.disabled = current >= maxForRow;
      if (removeBtn) removeBtn.hidden = rows.length <= 1;
    });

    if (addBtn) {
      var allRowsFilled = rows.every(function (r) { return !!r.getAttribute('data-scent-title'); });
      addBtn.hidden = !(allRowsFilled && total < MAX_TOTAL);
    }
  }

  function wireRow(row) {
    var trigger = row.querySelector('[data-duo-trigger]');
    var panel = row.querySelector('[data-duo-panel]');
    var triggerImg = row.querySelector('[data-duo-trigger-img]');
    var triggerText = row.querySelector('[data-duo-trigger-text]');
    var options = row.querySelectorAll('[data-duo-option]');
    var minusBtn = row.querySelector('[data-duo-qty-minus]');
    var plusBtn = row.querySelector('[data-duo-qty-plus]');
    var qtyValueEl = row.querySelector('[data-duo-qty-value]');
    var removeBtn = row.querySelector('[data-duo-remove]');

    if (trigger && panel) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !panel.hasAttribute('hidden');
        closeAllPanels();
        if (!isOpen) { panel.removeAttribute('hidden'); trigger.setAttribute('aria-expanded', 'true'); }
      });
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        if (option.getAttribute('data-disabled') === 'true') return;
        var title = option.getAttribute('data-title');
        var handle = option.getAttribute('data-handle');
        var image = option.getAttribute('data-image');

        row.setAttribute('data-scent-title', title);
        row.setAttribute('data-scent-handle', handle);
        if (!row.getAttribute('data-qty')) row.setAttribute('data-qty', '1');

        if (triggerText) triggerText.textContent = title;
        if (triggerImg) triggerImg.style.backgroundImage = 'url(' + image + ')';

        options.forEach(function (o) { o.classList.remove('duo-picker__option--selected'); });
        option.classList.add('duo-picker__option--selected');

        panel.setAttribute('hidden', '');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (errorEl) errorEl.setAttribute('hidden', '');

        refreshRowConstraints(); updateCount(); updateProperties();
      });
    });

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        var qty = parseInt(row.getAttribute('data-qty') || '1', 10);
        if (qty > 1) {
          qty -= 1;
          row.setAttribute('data-qty', String(qty));
          if (qtyValueEl) qtyValueEl.textContent = String(qty);
        }
        refreshRowConstraints(); updateCount(); updateProperties();
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        var qty = parseInt(row.getAttribute('data-qty') || '1', 10);
        var others = totalSelected() - rowQty(row);
        if (qty < MAX_TOTAL - others) {
          qty += 1;
          row.setAttribute('data-qty', String(qty));
          if (qtyValueEl) qtyValueEl.textContent = String(qty);
        }
        refreshRowConstraints(); updateCount(); updateProperties();
      });
    }
    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        row.remove();
        refreshRowConstraints(); updateCount(); updateProperties();
      });
    }
  }

  wireRow(rowTemplate);

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (totalSelected() >= MAX_TOTAL) return;
      var newRow = rowTemplate.cloneNode(true);
      newRow.setAttribute('data-duo-row', String(getRows().length + 1));
      newRow.removeAttribute('data-scent-title');
      newRow.removeAttribute('data-scent-handle');
      newRow.setAttribute('data-qty', '1');
      var tText = newRow.querySelector('[data-duo-trigger-text]');
      if (tText) tText.textContent = 'Select a scent';
      var tImg = newRow.querySelector('[data-duo-trigger-img]');
      if (tImg) tImg.style.backgroundImage = '';
      var qv = newRow.querySelector('[data-duo-qty-value]');
      if (qv) qv.textContent = '1';
      newRow.querySelectorAll('[data-duo-option]').forEach(function (o) { o.classList.remove('duo-picker__option--selected'); });
      var newPanel = newRow.querySelector('[data-duo-panel]');
      if (newPanel) newPanel.setAttribute('hidden', '');

      rowsContainer.appendChild(newRow);
      wireRow(newRow);
      refreshRowConstraints(); updateCount(); updateProperties();
    });
  }

  refreshRowConstraints();
  updateCount();

  if (form) {
    form.addEventListener('submit', function (e) {
      if (totalSelected() < MAX_TOTAL) {
        e.preventDefault();
        e.stopPropagation();
        if (errorEl) errorEl.removeAttribute('hidden');
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  }
}
